import React from 'react'
import { CurrentUserContext } from '../../../libraries/auth'
import config from '../../../config'
import Button from '../form/Button'

export const FeedbackButton: React.FC = () => {
    const { currentUser } = React.useContext(CurrentUserContext)
    
    const feedbackUrl = `${config.VITE_FEEDBACK_URL}?email=${encodeURIComponent(currentUser?.email || '')}`
    
    return (
        <div className='fixed bottom-1 right-1 z-[1000]'>
            <a 
                href={feedbackUrl}
                target='_blank'
                rel='noopener noreferrer'
                className='inline-block'
            >
                <Button variant='feedback' size='sm'>
                    Feedback
                </Button>
            </a>
        </div>
    )
} 